module.exports = __webpack_public_path__ + "static/img/sedan-bluegrey.3e3d694.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/sedan-bluegrey.svg
// module id = rz1d
// module chunks = 82